/**
 * 2018年9月11日    ****  薛加志  ****
 * 所有非会员页面上显示的文案数据全部定义在此
 */

/**
 * 评论区内容
 * commentData:  评论区数据  Object
 *    privTitle: icon标题
 *    iconUrl:   icon地址  提示：注意
 *    itemClass: 每个项目添加 class 是为了给每个item进行定位并且改变箭头位置
 *    clickShow: 点击展示
 *    actionType: 埋点
 *    comments:  评论数据
 *      commentText: 评论内容
 *      privResult:  开通特权后的效果
 *      result:      具体结果
 *      commentsFrom:评论用户来自哪里
 * 
 */
export const commentData = {
    // 求职特权数据
    jobPrivData: [
        {
            privTitle: '简历置顶',
            iconUrl: require('../assets/imgs/icon-jlzd.png'),
            itemClass: 'item-jlzd',
            clickShow: 'jlzd',
            actionType: 'pc-cvip-huiyuantequan-jlzd-dj-0',
            comments: [
                {
                    commentText: '应聘文员工作竞争压力大，购买会员以前总是隔几天才会有人联系我面试，自从使用了<span class="mark-light">简历置顶</span>之后，每天都会收到5-6个面试电话，真是太好了。',
                    privResult: '该用户简历日均被下载：',
                    result: '20次',
                    commentFrom: '——来自河北的用户'
                },
                {
                    commentText: '因为没上过大学，虽然经验丰富，还是匹配不了高薪。<span class="mark-light">使用简历置顶后</span>，我的简历能被企业HR直接搜索到，今天就有三家公司邀请我去面试！',
                    privResult: '该用户简历日均被下载：',
                    result: '32次',
                    commentFrom: '——来自深圳的用户'
                },
                {
                    commentText: '想找个工作真不容易，投了几十个工作都没人联系，前天买了会员，这几天好几个公司联系我，说<span class="mark-light">看到我的简历在最上面</span>，让我去面试。',                                
                    privResult: '该用户简历日均被下载：',
                    result: '15次',
                    commentFrom: '——来自辽宁的用户'
                }
            ],
        },
        {
            privTitle: '应聘优先',
            iconUrl: require('../assets/imgs/icon-ypyx.png'),
            itemClass: 'item-ypyx',
            clickShow: 'ypyx',
            actionType: 'pc-cvip-huiyuantequan-ypyx-dj-0',
            comments: [
                {
                    commentText: '以前投递总感觉企业没有看，自从开通了会员，投递的简历几乎都是当天就有反馈，研究了一下会员特权，才知是<span class="mark-light">应聘优先</span>。希望这类特权越来越多',                                
                    privResult: '该用户简历当天被查率为：',
                    result: '70%',
                    commentFrom: '——来自北京的用户'
                },
                {
                    commentText: '我干货车司机有二十多年了，但找工作总是快不过比我年轻很多的小伙子，他们比我手机玩的好啊！自从我使用了<span class="mark-light">应聘优先特权</span>，不到3天就签了新单位。',                                
                    privResult: '该用户使用特权前后，简历查看率提升了：',
                    result: '340%',
                    commentFrom: '——来自河南的用户'
                },
                {
                    commentText: '以前投完简历之后总是将时间耗费在无谓的等待中，那天听室友说她充了会员以后收到好多电话，我也试了试，果然<span class="mark-light">投完简历当天就有人联系</span>，开心。',                                
                    privResult: '该用户简历当天被查率为：',
                    result: '80%',
                    commentFrom: '——来自天津的用户'
                }
            ],
            
        },
        // {
        //     privTitle: '极速沟通',
        //     iconUrl: require('../assets/imgs/icon-jsgt.png'),
        //     itemClass: 'item-jsgt',
        //     clickShow: 'jsgt',
        //     actionType: 'pc-cvip-huiyuantequan-jsgt-dj-0',
        //     comments: [
        //         {
        //             commentText: '我是一个宝妈，对社会上的工作不太了解，找工作喜欢<span class="mark-light">先打电话</span>问一下具体信息再进行投递，会员的这个特权正好可以满足我，希望以后有更多实用的特权',                                
        //             privResult: '该用户平均每天节省时间：',
        //             result: '1h',
        //             commentFrom: '——来自山东的用户'
        //         },
        //         {
        //             commentText: '每次写简历都头疼，能做8分，但简历上就能看出来3分。当我知道<span class="mark-light">能和企业直接通电话</span>，立马买了会员。这不电话里直接自我介绍，说的明明白白，赞！',                                
        //             privResult: '该用户在没有简历的情况下，2天成功签约',
        //             result: '',
        //             commentFrom: '——来自湖北的用户'
        //         },
        //         {
        //             commentText: '刚刚毕业，在58上找工作，想先了解一下公司和岗位的情况再投递，有了会员以后<span class="mark-light">可以提前打电话先问清楚了</span>，有些工作不合适就不投简历了。',                                
        //             privResult: '该用户平均每天投递有效简历：',
        //             result: '10个',
        //             commentFrom: '——来自山西的用户'
        //         }
        //     ],
                                    
        // },
        {
            privTitle: '免费刷新',
            iconUrl: require('../assets/imgs/icon-wxsx.png'),
            itemClass: 'item-wxsx',
            clickShow: 'wxsx',
            actionType: 'pc-cvip-huiyuantequan-wxsx-dj-0',
            comments: [
                {
                    commentText: '作为学生党，在第一次就把简历写好了之后就不会再有更新了，幸好会员可以让我<span class="mark-light">每天免费的刷刷刷</span>，简历的排名也会实时调整，开心',                                
                    privResult: '当天该用户简历排名上升：',
                    result: '108名',
                    commentFrom: '——来自吉林的用户'
                },
                {
                    commentText: '这几天找工作，没面试的时候<span class="mark-light">我就在家刷简历</span>，确实联系我的企业比之前多了不少，哈哈哈，没白刷有效果我就知足了，为自己开心！',                                
                    privResult: '该用户刷新简历后，简历查看率提升了：',
                    result: '280%',
                    commentFrom: '——来自辽宁的用户'
                },
                {
                    commentText: '听公司hr说投递的时间决定你的简历位置，但HR一般只会看前面一两页，所以每天最好都刷新简历，<span class="mark-light">刷新以后就能排在前面，更容易被看到。</span>',                                
                    privResult: '当天该用户简历排名上升：',
                    result: '180名',
                    commentFrom: '——来自福建的用户'
                }
            ],
        },
        {
            privTitle: '投递翻倍',
            iconUrl: require('../assets/imgs/icon-tdfb.png'),
            itemClass: 'item-tdfb',
            clickShow: 'tdfb',
            actionType: 'pc-cvip-huiyuantequan-tdfb-dj-0',
            comments: [
                {
                    commentText: '做我们商务司机这一行的，用人单位要求都很高，为了可以快速找工作，我都会投递好多个职位，<span class="mark-light">会员每天可投递25次</span>，简直是我们这类人群的福音啊~',                                
                    privResult: '该用户日均面试邀请：',
                    result: '3家公司',
                    commentFrom: '——来自上海的用户'
                },
                {
                    commentText: '找工作两周了，每天都投满15次，差不多两天才一个面试。买完会员我<span class="mark-light">能投25次了</span>，现在天天都能去面试了，效果不错，大家可以一试！',                                
                    privResult: '该用户日均面试邀请：',
                    result: '1.5家公司',
                    commentFrom: '——来自广西的用户'
                },
                {
                    commentText: '有些公司投了简历没有答复，也不知道是不合适，还是已经招到人了，所以还是得海投啊，但是投多了就不让投了，开通会员以后<span class="mark-light">每天能投25个岗位</span>，够用了。',                                
                    privResult: '该用户日均面试邀请：',
                    result: '3家公司',
                    commentFrom: '——来自黑龙江的用户'
                }
            ],
        },
        {
            privTitle: '求职分析',
            iconUrl: require('../assets/imgs/icon-qzfx.png'),
            itemClass: 'item-qzfx',
            clickShow: 'qzfx',
            actionType: 'pc-cvip-huiyuantequan-qzfx-dj-0',
            comments: [
                {
                    commentText: '我主要想找保安之类的工作，之前没有使用过58同城，不知道怎么能快速找到工作，幸好会员中的<span class="mark-light">求职分析</span>，告诉我每天应该做什么，按指示操作，一点都不操心',                                
                    privResult: '该用户求职竞争力分数：',
                    result: '90分',
                    commentFrom: '——来自青海的用户'
                },
                {
                    commentText: '以前不好找工作，每天随便投投面面，越来越失落。看完求职分析。我<span class="mark-light">按照软件提示挨个操作完再去投递职位</span>，终于有几家心仪公司联系我了。',                                
                    privResult: '该用户求职竞争力分数：',
                    result: '90分',
                    commentFrom: '——来自黑龙江的用户'
                },
                {
                    commentText: '第一次找工作，也不知道应该怎么找，在58上看会员有个求职分析就试了试，感觉不错，从写简历到搜工作到投简历都有提示，<span class="mark-light">一步步跟着做顺利找到工作了</span>。',                                
                    privResult: '该用户求职竞争力分数：',
                    result: '90分',
                    commentFrom: '——来自广东的用户'
                }
            ],
        }
    ],
    // 求职保障数据
    jobSafeData: [
        {
            privTitle: '无效包赔',
            iconUrl: require('../assets/imgs/icon-wxbp.png'),
            itemClass: 'item-wxbp',
            clickShow: 'wxbp',
            actionType: 'pc-cvip-huiyuantequan-wxbp-dj-0',
            comments: [
                {
                    commentText: '本来对购买金卡很犹豫，但是看到<span class="mark-light">没有面试6倍赔付</span>之后果断入手，当时想：能找到工作最好，如果不行也可以得到赔偿。我得到了赔偿还找到了工作~',
                    privResult: '该用户最终获得赔偿：',
                    result: '160元',
                    commentFrom: '——来自浙江的用户'
                },
                {
                    commentText: '在职找工作一周还没找到，最后买了求职金卡，主要是抱着有效果最好，没有还可以得赔偿的想法买的，不过我在短时间内找到了工作，没有机会去<span class="mark-light">申请赔付</span>~',
                    privResult: '该用户在会员购买10内找到了工作',
                    result: '',
                    commentFrom: '——来自东莞的用户'
                },
                {
                    commentText: '本来就是冲着能有更好的求职效果来的，最后也通过会员如愿找到了工作，不过我有个朋友买了会员但是通过其他渠道找到了工作，最后<span class="mark-light">申请赔付也给赔了</span>',                                
                    privResult: '该用户朋友最终获得赔偿：',
                    result: '160元',
                    commentFrom: '——来自江西的用户'
                }
            ],
        },
        // {
        //     privTitle: '信息保真',
        //     iconUrl: require('../assets/imgs/icon-xxbz.png'),
        //     itemClass: 'item-xxbz',
        //     clickShow: 'xxbz',
        //     actionType: 'pc-cvip-huiyuantequan-xxbz-dj-0',
        //     comments: [
        //         {
        //             commentText: '当我在浏览一家公司职位并获取到电话，打电话询问发现对方含糊不清，不能清楚的描述该岗位的具体任职要求，而且薪资明显高出同岗位很多，在我再三确认后，该职位只是这家公司用来吸引求职者的，挂掉电话后我点击了举报，<span class="mark-light">58很快就审核通过了，我也很快获得了100块的理赔。<span>',
        //             privResult: '',
        //             result: '',
        //             commentFrom: '——来自云南的用户'
        //         },
        //         {
        //             commentText: '当我在浏览一家公司职位并获取到电话，打电话询问发现对方含糊不清，不能清楚的描述该岗位的具体任职要求，而且薪资明显高出同岗位很多，在我再三确认后，该职位只是这家公司用来吸引求职者的，挂掉电话后我点击了举报，<span class="mark-light">58很快就审核通过了，我也很快获得了100块的理赔。<span>',
        //             privResult: '',
        //             result: '',
        //             commentFrom: '——来自云南的用户'
        //         },
        //         {
        //             commentText: '当我在浏览一家公司职位并获取到电话，打电话询问发现对方含糊不清，不能清楚的描述该岗位的具体任职要求，而且薪资明显高出同岗位很多，在我再三确认后，该职位只是这家公司用来吸引求职者的，挂掉电话后我点击了举报，<span class="mark-light">58很快就审核通过了，我也很快获得了100块的理赔。<span>',
        //             privResult: '',
        //             result: '',
        //             commentFrom: '——来自云南的用户'
        //         }
        //     ],
        // },
        {
            privTitle: '财产安全',
            iconUrl: require('../assets/imgs/icon-ccaq.png'),
            itemClass: 'item-ccaq',
            clickShow: 'ccaq',
            actionType: 'pc-cvip-huiyuantequan-ccaq-dj-0',
            comments: [
                {
                    commentText: '前段时间去一家商贸公司面试，顺利通过，但当场需要缴纳150块钱体检费，最后才发现这是一家靠骗取求职者体检费用的公司，<span class="mark-light">举报给58后，58很快下线了该企业，我也顺利从58获得损失赔偿！<span>',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自新疆的用户'
                },
                {
                    commentText: '前段时间去一家商贸公司面试，顺利通过，但当场需要缴纳150块钱体检费，最后才发现这是一家靠骗取求职者体检费用的公司，<span class="mark-light">举报给58后，58很快下线了该企业，我也顺利从58获得损失赔偿！<span>',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自新疆的用户'
                },
                {
                    commentText: '前段时间去一家商贸公司面试，顺利通过，但当场需要缴纳150块钱体检费，最后才发现这是一家靠骗取求职者体检费用的公司，<span class="mark-light">举报给58后，58很快下线了该企业，我也顺利从58获得损失赔偿！<span>',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自新疆的用户'
                }
            ],
        },
        {
            privTitle: '专属客服',
            iconUrl: require('../assets/imgs/icon-zskf.png'),
            itemClass: 'item-zskf',
            clickShow: 'zskf',
            actionType: 'pc-cvip-huiyuantequan-zskf-dj-0',
            comments: [
                {
                    commentText: '我身边的人从来没用过58同城，导致我每次遇到问题都不知道问谁，<span class="mark-light">幸好会员的24小时回复特权</span>，可以快速的解决我的问题，终于不用因为不懂而发愁了',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自江西的用户'
                },
                {
                    commentText: '有一次在投递的时候总是投递失败，后来找了客服才知道是因为我的手机号验证出了问题，<span class="mark-light">客服小姐姐耐心的告诉我要怎么去操作</span>~给客服小姐姐打call！',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自天津的用户'
                },
                {
                    commentText: '第一次用58求职，操作都不是特别了解，看到<span class="mark-light">会员有24小时回复特权</span>，把问题都反馈了一下，当天客服给我回复告诉我该如何操作，之后有好多企业给我打电话',                                
                    privResult: '',
                    result: '',
                    commentFrom: '——来自河北的用户'
                }
            ],
        }
    ],
    // 身份特权数据
    idenPrivData: [
        {
            privTitle: '尊贵标识',
            iconUrl: require('../assets/imgs/icon-zgbs.png'),
            itemClass: 'item-zgbs',
            clickShow: 'zgbs',
            actionType: 'pc-cvip-huiyuantequan-zgbs-dj-0',
            comments: [
                {
                    commentText: '以前在企业做hr时，对<span class="mark-light">有标识的简历</span>特别容易产生信赖感，现在轮到自己求职了，也希望我的简历可以获得hr的信赖，为自己赢得更多机会',
                    privResult: '该用户日均接到面试电话：',
                    result: '5次',
                    commentFrom: '——来自武汉的用户'
                },
                {
                    commentText: '在求职时无时无刻都能看的自己的<span class="mark-light">会员标识</span>，大大满足了自己的“虚荣心”，最主要是价格很便宜。',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自上海的用户'
                },
                {
                    commentText: '我这个人吧好面子，qq、游戏啥的都想显示皇冠，这次看到在58<span class="mark-light">会员简历有皇冠标识</span>，心想，找工作这么重要的事情那必须整一个，很快就找到了工作',                                
                    privResult: '该用户日均接到面试邀请：',
                    result: '3次',
                    commentFrom: '——来自吉林的用户'
                }
            ],
        },
        // {
        //     privTitle: '个人认证',
        //     iconUrl: require('../assets/imgs/icon-grrz.png'),
        //     itemClass: 'item-grrz',
        //     clickShow: 'grrz',
        //     actionType: 'pc-cvip-huiyuantequan-grrz-dj-0',
        //     comments: [
        //         {
        //             commentText: '上次去面试，面试结束跟hr闲聊，他说现在没有做个人认证的用户都很少会邀请面试，一方面是求职态度问题，另方面是可信度的问题。<span class="mark-light">当时很庆幸自己认证了</span>',
        //             privResult: '该用户日均接到面试邀请：',
        //             result: '3次',
        //             commentFrom: '——来自云南的用户'
        //         },
        //         {
        //             commentText: '认证不仅可以证明我是一个正常的求职人，还证明了我的态度。希望可以多出一些<span class="mark-light">其他职位相关的认证~</span>',
        //             privResult: '该用户日均简历被下载：',
        //             result: '20次',
        //             commentFrom: '——来自广东的用户'
        //         },
        //         {
        //             commentText: '21世纪信用会越来越值钱，有一回面试HR就跟我说，宁愿承认自己的缺陷也绝对不能欺骗公司，否则这样的人再有能力也不会被录用的，我就<span class="mark-light">买了会员做了认证</span>',                                
        //             privResult: '该用户日均简历被下载：',
        //             result: '20次',
        //             commentFrom: '——来自沈阳的用户'
        //         }
        //     ],
        // },
        {
            privTitle: '黄金亮点',
            iconUrl: require('../assets/imgs/icon-hjld.png'),
            itemClass: 'item-hjld',
            clickShow: 'hjld',
            actionType: 'pc-cvip-huiyuantequan-hjld-dj-0',
            comments: [
                {
                    commentText: '入职之后，我的hr跟我说，当时是因为在海量简历中，看到了我的一个特点跟这个工作很匹配才会找我入职，后来才知道是<span class="mark-light">黄金亮点</span>~还是挺感谢58的工作人员的~',
                    privResult: '该用户日均简历被查看：',
                    result: '30次',
                    commentFrom: '——来自沈阳的用户'
                },
                {
                    commentText: '我朋友说，在58招人，<span class="mark-light">在筛简历时总会注意到添加了亮点的简历</span>，也会优先查看这些简历，所以我写完简历会立即设置符合自己的亮点。',
                    privResult: '',
                    result: '',
                    commentFrom: '——来自莱芜的用户'
                },
                {
                    commentText: '我是个司机，有一天接到了面试的通知，当天只有我一个人，老板跟我说，简历差不多，但是我的简历有一个<span class="mark-light">黄金亮点</span>写的开车从未延误，所以优先约我来面试',                                
                    privResult: '该用户从50份简历中被选中面试最后入职',
                    result: '',
                    commentFrom: '——来自广西的用户'
                }
            ],
        }
    ]
}

/**
 * cardData:  购买会员卡区数据   Array
 *    cardTitle:     购买期限
 *    cardDesc:      购买赠送说明
 *    cardPrice:     价格
 *    originPrice:   原价
 *    cardDiscounts: 折扣
 *    hotSellClass:  热销类名  给热销的卡片增加icon
 *    cardValid:     会员有效期
 *    actionType:    埋点
 *    cardType:      会员卡类型
 * 
 * 
 */
export const cardData = [
    {
        cardTitle: '7天体验版',
        cardDesc: '简历置顶等多项特权',
        cardPrice: 18,
        originPrice: '',
        cardDiscounts: '',
        hotSellClass: '',
        cardValid: '1周',
        actionType: 'pc-cvip-taocan-tiyanban-ljkt-fhy',
        cardType: 19,
        hoverText: `
            <p>简历置顶等多项特权</p>
            <p>简历置顶</p>
            <p>应聘优先</p>
            <p>免费刷新简历</p>
            <p>免费求职诊断等</p>
        `,
        tempText: ''
    },
    {
        cardTitle: '30天基础版',
        cardDesc: '简历置顶等多项特权',
        cardPrice: 28,
        originPrice: '￥72',
        cardDiscounts: '4折优惠',
        hotSellClass: 'hot-sell',
        cardValid: '1个月',
        actionType: 'pc-cvip-taocan-jichuban-ljkt-fhy',
        cardType: 19,
        hoverText: `
            <p>简历置顶等多项特权</p>
            <p>简历置顶</p>
            <p>应聘优先</p>
            <p>免费刷新简历</p>
            <p>免费求职诊断等</p>
        `,
        tempText: ''
    },
    {
        cardTitle: '30天升级版',
        cardDesc: '基础版特权+专属客服等特权',
        cardPrice: 60,
        originPrice: '￥216',
        cardDiscounts: '3折优惠',
        hotSellClass: '', 
        cardValid: '1个月',
        actionType: 'pc-cvip-taocan-shengjiban-ljkt-fhy',
        cardType: 20,
        hoverText: `
            <p>简历置顶等多项特权</p>
            <p>简历置顶</p>
            <p>应聘优先</p>
            <p>免费刷新简历</p>
            <p>免费求职诊断等</p>
        `,
        tempText: ''
    },
    {
        cardTitle: '30天升级版',
        cardDesc: '基础版特权+专属客服等特权',
        cardPrice: 60,
        originPrice: '￥216',
        cardDiscounts: '3折优惠',
        hotSellClass: '', 
        cardValid: '1个月',
        actionType: 'pc-cvip-taocan-shengjiban-ljkt-fhy',
        cardType: 20,
        hoverText: `
            <p>简历置顶等多项特权</p>
            <p>简历置顶</p>
            <p>应聘优先</p>
            <p>免费刷新简历</p>
            <p>免费求职诊断等</p>
        `,
        tempText: ''
    }
]

/**
 * introData: 会员特权介绍数据  Array
 *    introTitle:   特权标题
 *    introDesc:    特权描述
 *    introBtnText: 购买按钮文字
 *    introDemoImg: 特权示例图片
 */
export const introData = [
    {
        introTitle: '如何让你的简历脱颖而出？',
        introDesc: [
            '黄金亮点：个人专属优势标签，脱颖而出', 
            '简历置顶：优先展示在简历库列表顶部', 
            '刷新简历：免费刷新简历，提升简历排名', 
            '应聘优先：会员投递的简历均会被企业优先处理'],
        introBtnText: '我要脱颖而出',
        actionType: 'pc-cvip-video-tuoyingerchu',
        tabActionType: 'pc-cvip-video-tab-baoguang',
        introDemoImg: require('../assets/imgs/demo-img-resume.png')
    },
    {
        introTitle: '如何快速与企业取得联系？',
        introDesc: [
            '每天25次投递机会，心仪职位一网打尽', 
            '详情页点击电话，无障碍查看企业电话',
            '在线沟通，简单高效，实时回复'],
        introBtnText: '我要快速联系企业',
        actionType: 'pc-cvip-video-kuaisulianxiqiye',
        tabActionType: 'pc-cvip-video-tab-lianxi',
        introDemoImg: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/c407vbhe__w2004_h1600.png'
    },
    {
        introTitle: '购买会员后没有效果怎么办？',
        introDesc: [
            '无效包赔，会员期间，5天内未收到面试邀请，可获得会员价格的6倍赔偿！',
            '专属客服，24小时及时解疑答惑',
            '赠送求职意外险，求职路上为您保驾护航'],
        introBtnText: '我要享受保障',
        actionType: 'pc-cvip-video-xiangshoubaozhang',
        tabActionType: 'pc-cvip-video-tab-baozhang',
        introDemoImg: require('../assets/imgs/demo-img-buyvip.png')
    }
]

// 会员特权表格数据
export const privilegesData = {
    thead: [
        {
            width: 200,
            title: '特权列表',
            desc: ''
        },
        {
            width: 249,
            title: '7天体验版',
            desc: '简历置顶等多项特权',
            using: false
        },
        {
            width: 249,
            title: '30天基础版',
            desc: '简历置顶等多项特权',
            using: false
        },
        {
            width: 249,
            title: '30天升级版',
            desc: '基础版特权+专属客服',
            using: false
        }
    ],
    tbody: [
        {
            data : [
                '简历置顶',
                '会员标识',
                '应聘优先',
                '免费刷新',
                // '极速沟通',
                '投递特权',
                '求职诊断',
                // '信息保真险',
                '财产安全险',
                '无效包赔',
                '直通卡',
                '专属客服',
                '面试技巧',
                '防骗安全提醒',
                '简历服务',
                '用户关怀'
            ]
        },
        {
            class: 'icon',
            data: [
                'able',     // 简历置顶,
                'able',     // 会员标识
                'able',     // 应聘优先
                'able',     // 免费刷新
                // 'able',     // 极速沟通
                'able',     // 投递特权
                'able',     // 求职诊断
                // 'able',     // 信息保真险
                'able',     // 财产安全险
                'able',     // 无效包赔
                'disabled',  // 直通卡
                'disabled',  // 专属客服
                'disabled',  // 面试技巧
                'disabled',  // 防骗安全提醒
                'disabled',  // 简历服务
                'disabled'   // 用户关怀
            ]
        },
        {
            class: 'icon',
            data: [
                'able',     // 简历置顶,
                'able',     // 会员标识
                'able',     // 应聘优先
                'able',     // 免费刷新
                // 'able',     // 极速沟通
                'able',     // 投递特权
                'able',     // 求职诊断
                // 'able',     // 信息保真险
                'able',     // 财产安全险
                'able',     // 无效包赔
                'disabled',  // 直通卡
                'disabled',  // 专属客服
                'disabled',  // 面试技巧
                'disabled',  // 防骗安全提醒
                'disabled',  // 简历服务
                'disabled'   // 用户关怀
            ]
        },
        {
            class: 'icon',
            data: [
                'able',     // 简历置顶,
                'able',     // 会员标识
                'able',     // 应聘优先
                'able',     // 免费刷新
                // 'able',     // 极速沟通
                'able',     // 投递特权
                'able',     // 求职诊断
                // 'able',     // 信息保真险
                'able',     // 财产安全险
                'able',     // 无效包赔
                'able',     // 直通卡
                'able',     // 专属客服
                'able',     // 面试技巧
                'able',     // 防骗安全提醒
                'able',     // 简历服务
                'able'      // 用户关怀
            ]
        }
    ]
}






// WEBPACK FOOTER //
// ./src/data/data.js